define('areas/shopitemtemplate/commands/writeshopitemtemplatecommand',["require", "exports", "services/navigator"], function (require, exports, Navigator) {
    "use strict";
    var WriteShopItemTemplateCommand = (function () {
        function WriteShopItemTemplateCommand() {
        }
        WriteShopItemTemplateCommand.prototype.execute = function (unit) {
            Navigator.navigateTo("shopitemtemplate", "write", "/neu");
        };
        return WriteShopItemTemplateCommand;
    }());
    return WriteShopItemTemplateCommand;
});

